import React, {Component} from 'react';
import './index.scss';
import CrgtEvent from '../CrgtEvent';

export default class WiFiButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showText: true,
      workType: 1
    };
  }
  componentDidMount() {
    this.fetchWorkType();
  }

  async fetchWorkType() {
    const workType = await CrgtEvent.getNetworkType()
    this.setState({
      workType
    })
  }

  handleClick = () => {
    this.setState({ showText: !this.state.showText });
  }
  render(){
    const wifiImg = 'https://static.ccrgt.com/movie/assets/images/wifi.png';
    const { text = '连接高铁WiFi观看', imgUrl = wifiImg, background = '#fea11d', color = '#fff'} = this.props;
    return (<>{
      this.state.workType !== 1 ? <button className="wifi-button" style={{background, color}} onClick={this.handleClick}>
        <img src={imgUrl} alt="" />
        <span>{this.state.showText ? text: ''}</span>
      </button> : <></>
    }</>)
  }
}